import { isOffShelf } from './offShelf';

/** Shared by the Categories & Dishes page and each category card, so the two always agree. */

export const normalizeDishQuery = (query) => (query || '').trim().toLowerCase();

export const matchesDishQuery = (item, normalizedQuery) => {
  if (!normalizedQuery) {
    return true;
  }
  return ['name', 'altName', 'description'].some((field) =>
    (item[field] || '').toLowerCase().includes(normalizedQuery)
  );
};

/**
 * The dishes of one category that survive the page's filters, each paired with its index in the
 * category's own `items` array.
 *
 * The index has to travel with the dish. Reordering, dropping a choice group onto a dish and "move to
 * top" all address `category.items` by position, so handing those callbacks a position within a
 * *filtered* list edits whichever dish happens to sit at that position in the full one.
 */
export const filterCategoryItems = (
  items,
  { query = '', offShelfOnly = false, offShelfMap, now } = {}
) => {
  const normalizedQuery = normalizeDishQuery(query);

  return (items || []).reduce((kept, item, index) => {
    if (!item) {
      return kept;
    }
    if (offShelfOnly && !isOffShelf(item, offShelfMap, now)) {
      return kept;
    }
    if (!matchesDishQuery(item, normalizedQuery)) {
      return kept;
    }
    kept.push({ item, index });
    return kept;
  }, []);
};

/** A category is worth showing when it still has a dish to show, or when nothing is filtered. */
export const hasVisibleItems = (category, options) =>
  filterCategoryItems(category && category.items, options).length > 0;
